import React, { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import { useNavigate } from "react-router-dom";

const SOPAdd = () => {
  const navigate = useNavigate();
  const [senderUserId, setSenderUserId] = useState(0);
  const [allSites, setAllSites] = useState([]); 
  const [selectedSites, setSelectedSites] = useState([]); 
  const [files, setFiles] = useState([]);

  const titleRef = useRef(null);
  const descriptionRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      let result = await Apiservice.AllSites({ status: 0 });
      if (result.success === true) {
        setAllSites(result.data);
      }
    };
    fetchData();

    let userId = localStorage.getItem("user_id");
    if (userId) {
      setSenderUserId(userId);
    }
  }, []);

  const handleFileChange = (e) => {
    setFiles(Array.from(e.target.files));
  };

  const handleSiteToggle = (siteId) => {
    setSelectedSites((prev) =>
      prev.includes(siteId)
        ? prev.filter((id) => id !== siteId)
        : [...prev, siteId]
    );
  };

  const handleSelectAll = () => {
    if (selectedSites.length === allSites.length) {
      setSelectedSites([]);
    } else {
      setSelectedSites(allSites.map((s) => s.id.toString()));
    }
  };

  const handleAdd = async () => {
    try {
      let formData = new FormData();
      formData.append("sentUserId", senderUserId);

      selectedSites.forEach((siteId) => formData.append("siteId[]", siteId));
      formData.append("title", titleRef.current.value);
      formData.append("description", descriptionRef.current.value);

      files.forEach((file) => formData.append("files", file));

      let result = await Apiservice.SOPAdd(formData);

      if (result.success === true) {
        navigate("/sop");
      } else {
        alert(result.message);
      }
    } catch (err) {
      console.error("Error while adding SOP:", err);
      alert("Something went wrong!");
    }
  };

  return (
    <div className="container-fluid card shadow p-2 m-2">
      <h3 className="mb-3 text-center">Add SOP</h3>

      {/* Title */}
      <div className="row mb-3">
        <div className="col-2">Title</div>
        <div className="col-10">
          <input
            type="text"
            ref={titleRef}
            className="form-control form-control-sm"
          />
        </div>
      </div>

      {/* Description */}
      <div className="row mb-3">
        <div className="col-2">Description</div>
        <div className="col-10">
          <input
            type="text"
            ref={descriptionRef}
            className="form-control form-control-sm"
          />
        </div>
      </div>

      {/* Sites */}
      <div className="row mb-3">
        <div className="col-2">Sites</div>
        <div className="col-10">
          <div className="border rounded p-2" style={{ maxHeight: "150px", overflowY: "auto" }}>
            <div className="form-check mb-1">
              <input
                type="checkbox"
                className="form-check-input"
                checked={selectedSites.length === allSites.length && allSites.length > 0}
                onChange={handleSelectAll}
              />
              <label className="form-check-label">Select All</label>
            </div>
            {allSites.map((site) => (
              <div className="form-check mb-1" key={site.id}>
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={site.id}
                  checked={selectedSites.includes(site.id.toString())}
                  onChange={() => handleSiteToggle(site.id.toString())}
                />
                <label className="form-check-label">{site.name}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Files */}
      <div className="row mb-3">
        <div className="col-2">Files</div>
        <div className="col-10">
          <input
            type="file"
            className="form-control form-control-sm"
            multiple
            onChange={handleFileChange}
          />
          {files.length > 0 && (
            <ul className="mt-2 small text-muted">
              {files.map((file, idx) => (
                <li key={idx}>{file.name}</li>
              ))}
            </ul>
          )}
        </div>
      </div>

      {/* Submit */}
      <div className="row">
        <div className="col text-center">
          <button className="btn btn-primary btn-sm" onClick={handleAdd}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default SOPAdd;
